import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message, Modal, } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_position_add, api_position_edit} from '../../../api';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

// const { Header, Content, Footer, Sider } = Layout;
const { TextArea } = Input;
// const { Option } = Select;
const screenHeight = document.body.clientHeight;

const App =(props)=>{
    const {showModal, closeModal, rowInfo, refreshlist} = props;
    console.log('1111111111111111111111111111111111111-', rowInfo)
    const [form] = Form.useForm();
    const [bEdit,setBEdit] = useState(true);
    const [loading,setLoading] = useState(false);

    useEffect(() => {
      if(showModal){
        if(rowInfo.id == undefined){
          form.resetFields();
        } else {
          for (let key in rowInfo) {
            form.setFieldValue(key, rowInfo[key])
          }
        }
      }else{
        form.resetFields();
        setLoading(false);
      }
    }, [showModal]);

    const onFinish = async(value)=>{
      console.log(value);
      // if(!value.username){
      //   message.warn("请输入邮箱接口");
      //   return false;
      // }
      // setLoading(true);

      value.id = rowInfo.id;
      var fun = rowInfo.id ? api_position_edit : api_position_add;

      try {
        await fun(value).then((res) => {
          setLoading(false);
          console.log(fun+'-res-----------------', res);
          if (res.data.code == 9) {
            message.success("操作成功");
            closeModal();
            refreshlist();
          }else
            message.error(res.data.msg);
        });
        } catch (error) {
          message.error("网络异常");
          setLoading(false);
          return false;
        }
  }

  return (
    <Modal 
        key="userinfo"
        title={(rowInfo.id ? '编辑' :'新增')+'岗位'}
        open={showModal}
        width={600}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        确认
        </Button>] }
        onCancel={closeModal}>
          <Form form={form}
            className='loginForm reginfo'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            layout="horizontal"
            // onFinishFailed={this.onFinishFailed}
            autoComplete="off"
            labelAlign="left"
            labelCol={{span:5}}
            // style={{fontSize:12}}
            size="small"
            initialValues={{is_outlook_enabled:"0"}}
        >
            <Form.Item
                label="岗位名称"
                name="name"
                rules={[
                  {required: true, message: '请输入岗位名称',},
                ]}
            >
            <Input disabled={rowInfo.id?true:false} />
            </Form.Item>
            <Form.Item
                label="岗位描述"
                name="description"
            >
            <TextArea rows={4} placeholder="最多500个字" maxLength={500} />
            </Form.Item>

        </Form>
        </Modal>
  )
}
export default App
